/** AUTO-GENERATED — do not edit. Run: yarn sync:amp-registry */
export const AMP_TRACK_COMPONENT_VALUES = new Set<string>([
  // Actions
  'action-button',
  'add-users-button',
  'button-add-break',
  'button-download-chrome-extension',
  'button-download-desktop-app',
  'button-download-firefox-extension',
  'button-enable-screencasts',
  'button-give-feedback',
  'button-keep-me-posted',
  'button-setup-schedules',
  'export-button',

  // Controls
  'blur-screenshots',
  'date-selector',
  'dropdown-screencast-interval',
  'dropdown-who-can-see-screencasts',
  'email-text-box',
  'filter',
  'filter-all',
  'filter-identical',
  'filter-low-activity',
  'filter-unusual-activity',
  'form-field',
  'report-granularity-selector',
  'search-bar',
  'sort-column',
  'timezone-selector',
  'toggle',
  'toggle-browser-extension',
  'toggle-use-projects-tasks',
  'tool-selector',
  'user-group-selector',

  // Display
  'column-header',
  'create-notification-button',
  'custom-export-fields',
  'empty-state-message',
  'gear-button',
  'image',
  'page-title',
  'screenshot-thumbnail',
  'time-tracked-bar',
  'timeline-block',
  'widget',
  'widget-group',
  'widget-havent-tracked-time',

  // Navigation
  'active-users-tab',
  'archived-users-tab',
  'automatic-app-tab',
  'billing-details-tab',
  'browser-extension-tab',
  'calendar-provider-selector',
  'computers-tab',
  'custom-export-breakdown-selector',
  'custom-export-format-selector',
  'groups-scope-selector',
  'inactive-computers-tab',
  'integration-category-selector',
  'interactive-app-tab',
  'invoices-tab',
  'learn-more-about-each-app-button',
  'location-mode-selector',
  'native-tab',
  'nav-activity-summary',
  'nav-add-managers',
  'nav-ai-connections',
  'nav-ai-impact',
  'nav-approvals',
  'nav-attendance',
  'nav-bell-icon',
  'nav-benchmarks-ai',
  'nav-billing',
  'nav-breaks',
  'nav-change-company',
  'nav-company-flyout',
  'nav-company-settings',
  'nav-compliance-doctor',
  'nav-contact-us',
  'nav-custom-export',
  'nav-dashboard-dropdown',
  'nav-download',
  'nav-edit-time',
  'nav-email-notifications',
  'nav-executive-dashboard',
  'nav-groups',
  'nav-help-center',
  'nav-hours-tracked',
  'nav-insights',
  'nav-integrations',
  'nav-internet-connectivity',
  'nav-invite',
  'nav-meeting-insights',
  'nav-my-account',
  'nav-office-vs-remote',
  'nav-payroll',
  'nav-productivity-ratings',
  'nav-project-task-settings',
  'nav-projects-tasks-report',
  'nav-question-icon',
  'nav-referrals',
  'nav-reports-dropdown',
  'nav-schedules',
  'nav-screencasts',
  'nav-settings-dropdown',
  'nav-sign-out',
  'nav-software-cost-insights',
  'nav-take-a-tour',
  'nav-td-icon',
  'nav-team-dashboard',
  'nav-time-doctor-academy',
  'nav-timeline',
  'nav-unusual-activity',
  'nav-user-avatar',
  'nav-user-dashboard',
  'nav-users',
  'nav-web-app-usage',
  'new-automatic-users-tab',
  'open-side-panel',
  'pagination',
  'plan-selector',
  'productivity-entity-selector',
  'productivity-ratings-scope-selector',
  'side-panel',
  'side-panel-card',
  'side-panel-tab',
  'tab',
  'table-row-within-side-panel',
  'text-link',
  'unusual-activity-detail-selector',
]);

export const AMP_TRACK_COMPONENT_DETAILS: Readonly<Record<string, readonly string[]>> = {
  'action-button': ['save', 'approve', 'reject', 'cancel', 'submit', 'create', 'delete', 'header-upgrade', 'upgrade-continue', 'upgrade-cancel', 'upgrade-error-cancel', 'trial-offer-start', 'trial-offer-later', 'trial-offer-view-plans', 'trial-offer-cancel', 'trial-offer-cancel-confirm', 'trial-offer-keep'] as const,
  'calendar-provider-selector': ['all', 'google', 'outlook'] as const,
  'column-header': ['status'] as const,
  'date-selector': ['today', 'yesterday', 'past-7-days', 'past-30-days', 'custom', 'day-toggle', 'week-toggle', 'month-toggle', 'date-range-toggle', 'prev-arrow', 'next-arrow'] as const,
  'export-button': ['csv', 'pdf', 'main'] as const,
  filter: ['office-days', 'remote-days', 'identical-screenshots', 'approval-all', 'approval-pending', 'approval-approved', 'approval-disapproved'] as const,
  'form-field': ['license-cost'] as const,
  'gear-button': ['columns', 'settings'] as const,
  'groups-scope-selector': ['active', 'archived'] as const,
  image: ['screencasts-screenshot'] as const,
  'integration-category-selector': ['all', 'hris', 'payroll'] as const,
  'location-mode-selector': ['all', 'office', 'remote', 'hybrid'] as const,
  'open-side-panel': ['settings-side-panel', 'view-group-meetings-side-panel', 'view-user-meetings-side-panel'] as const,
  pagination: ['prev', 'next', 'first', 'last'] as const,
  'plan-selector': ['standard', 'premium'] as const,
  'productivity-entity-selector': ['users', 'web-apps'] as const,
  'productivity-ratings-scope-selector': ['group-ratings', 'individual-exceptions'] as const,
  'report-granularity-selector': ['day', 'week', 'month'] as const,
  'search-bar': ['main', 'group-search'] as const,
  'side-panel': ['layer-1-trigger', 'layer-2-trigger', 'layer-3-trigger'] as const,
  'side-panel-card': ['activity-level', 'idle-minutes', 'unproductive-websites', 'meeting-time', 'manually-added-time', 'all-websites-apps', 'productive', 'unproductive', 'neutral', 'unrated'] as const,
  'side-panel-tab': ['websites-apps', 'projects-tasks'] as const,
  'sort-column': ['total-time', 'activity-level', 'meeting-time', 'idle-minutes-percent', 'unproductive', 'unproductive-percent', 'status', 'pay'] as const,
  'table-row-within-side-panel': ['individual-user-trigger', 'individual-meeting-trigger'] as const,
  'text-link': ['learn-more', 'hours-tracked-report'] as const,
  'timeline-block': ['main-report', 'side-panel'] as const,
  toggle: ['screenshots-enabled', 'idle-timeout', 'blur-screenshots'] as const,
  'unusual-activity-detail-selector': ['graph', 'screencasts'] as const,
  'user-group-selector': ['main', 'users', 'groups'] as const,
  widget: ['highest-meeting-time', 'lowest-meeting-time', 'web-app-usage-meetings', 'idle-during-meetings', 'time-earned', 'roi-impact', 'prompt-categories', 'ai-tools-percentile', 'apps-usage-breakdown', 'highest-productive-ratio', 'breaks-list', 'time-breakdown'] as const,
  'widget-group': ['overview', 'top-users'] as const,
};

export const AMP_TRACK_COMPONENT_ALIASES: Readonly<Record<string, string>> = {
  'button-primary': 'action-button',
  'date-picker': 'date-selector',
  'nav-dashboard': 'nav-user-dashboard',
  'nav-item': 'nav-reports-dropdown',
  'search-input': 'search-bar',
  'toggle-switch': 'toggle',
};
